import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./CommitmentPerson.css";

function CommitmentPerson({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
}) {
  const navigate = useNavigate();

  return (
    <Row className="commitment-person align-items-center">
      <Col className="commitment-person-header">
        <h5 onClick={() => navigate(`/mycommitments/person/${id}`)}>
          {firstName} {lastName}
        </h5>
        <p>{language === "es" ? profileName : profileNameEnglish}</p>
      </Col>
    </Row>
  );
}

export default CommitmentPerson;
